/* -------------------------------------------------------------------------- */
/*                           Schema Contacts                                  */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const contact = new schema.Entity('contacts', {}, { idAttribute: 'contactId' });
export const contacts = new schema.Array(contact);
